import script from "./InquiryDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetail.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetail.vue?vue&type=style&index=0&id=5861fd6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5861fd6a"]])

export default __exports__